// A recipe as a table: ingredients down the left, each step to the right of
// what it takes in. Read-only; it's changed through its text.
import {
  layout,
  type Node,
  tableRows,
} from '@/app/recipe/recipe';
import classNames from 'classnames';

export const RecipeCard = (
  { steps, onEditText }: { steps: Node[], onEditText: () => void },
) => (
  <div className="recipe-card">
    <div className="recipe-toolbar">
      <span className="recipe-title">Recipe</span>
      <button title="Edit as text" onClick={onEditText}>Text</button>
    </div>
    <div className="recipe-scroll">
      {steps.length
        ? (
          <table>
            <tbody>
              {tableRows(layout(steps)).map((row, r) => (
                <tr key={r}>
                  {row.map(cell => (
                    <td
                      key={cell.col}
                      rowSpan={cell.rowSpan}
                      colSpan={cell.colSpan}
                      className={classNames({ step: cell.step })}>
                      {cell.text}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        )
        : <p className="recipe-empty">Nothing here yet</p>}
    </div>
  </div>
);
